import React, {Fragment, FunctionComponent, useContext, useMemo} from 'react';
import {observer} from "mobx-react";
import {Context} from "../../../store/context";
import {DEFAULT_LANG} from "../../../store/constants";

interface ITranslatedNode{
    id?:number;
}

const _TranslatedNode:FunctionComponent<ITranslatedNode> = ({id})=>{
    const {nodesStore, defaultDestinationsStore, languagesStore} = useContext(Context);
    const {currentIETF} = languagesStore;
    const {nodes} = nodesStore;
    const {defaultDestinations} = defaultDestinationsStore;

    const translation = useMemo(()=>{
        if(!currentIETF || !nodes?.length || !defaultDestinations?.length)
            return '';

        const node = nodes.find(n =>n.id === id);
        if(!node)
            return '';

        const names:string[] = [];
        for(const dest of node.destinations){
            const defDest = defaultDestinations.find(d => d.id === dest.destinationId);
            if(!defDest)
                continue;

            const ietfName = defDest.defaultDestinationNames.find(dn => dn.lang === currentIETF);
            if(ietfName)
            {
                names.push(ietfName.name);
                continue;
            }

            const defLangName = defDest.defaultDestinationNames.find(dn => dn.lang === DEFAULT_LANG);
            if(defLangName)
                names.push(defLangName.name)
        }

        return names.join(', ');
    },[id, currentIETF, nodes, defaultDestinations]);

    return <Fragment>{translation}</Fragment>;
}

const TranslatedNode = observer(_TranslatedNode);
export default TranslatedNode;
